import React, { Component } from "react";
import { Form, InputGroup, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import moment from "moment";
import {
  IProfileProps,
  IUploadState,
} from "../../interfaces/profile.interface";
import { IRootState } from "../../interfaces";
import {
  getProfileRequest,
  updateImageRequest,
  deleteImageRequest,
} from "../../action";
import { logger } from "../../helper/Logger";
import "react-datepicker/dist/react-datepicker.css";
import { message } from "../../common/messages";

class UploadImage extends Component<IProfileProps, IUploadState> {
  constructor(props: IProfileProps) {
    super(props);
    this.state = {
      email: "",
      errors: {},
      loading: false,
      imageFileName: "",
      imageFile: "",
    };
  }
  componentDidMount = () => {
    this.getProfileData();
  };

  componentDidUpdate = (prevProps: IProfileProps) => {
    const { profileReducer } = this.props;
    if (
      prevProps.profileReducer &&
      profileReducer &&
      profileReducer.isLoading !== prevProps.profileReducer.isLoading
    ) {
      this.getProfileData();
    }
  };

  getProfileData = () => {
    const { profileReducer } = this.props;
    if (
      profileReducer &&
      profileReducer.profileInfo &&
      Object.entries(profileReducer.profileInfo).length
    ) {
      const { profileInfo } = profileReducer;
      logger(profileInfo);

      const profileData: any = profileInfo;
      let { email } = profileData;
      this.setState({
        email: email,
      });
      logger(this.state.loading);
      logger("logger in did update");
    }
  };
  handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    if (name === "email") {
      return;
    }
    this.setState({
      ...this.state,
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: "",
      },
    });
  };

  handleImageFileSelect = async (e: any) => {
    let files = e.target.files;
    console.log("e.target image file select>>>>>>", e.target.files[0]);
    if (files && files[0] && files[0].name) {
      let imageFileName = files[0].name;
      this.setState({
        imageFileName: imageFileName,
        imageFile: files[0],
        errors: "",
      });
      if (
        !(
          imageFileName.indexOf(".png") != -1 ||
          imageFileName.indexOf(".jpeg") != -1 ||
          imageFileName.indexOf(".jpg") != -1
        )
      ) {
        this.setState({
          errors: { imageFileName: message.ValidImageTypeRequired },
        });
      }
    }
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { email, imageFile, imageFileName } = this.state;
    const data = {
      email: email,
      imageFile: imageFile,
      imagePath: imageFileName,
    };
    console.log(">>>>>>>>>>>>>>>>>>", data);
    // To validate form fields
    if (
      imageFileName.indexOf(".png") != -1 ||
      imageFileName.indexOf(".jpeg") != -1 ||
      imageFileName.indexOf(".jpg") != -1
    ) {
      const { updateProfileInfo } = this.props;
      if (updateProfileInfo) {
        this.setState({
          loading: true,
        });
        updateProfileInfo({
          ...data,
        });
      }
    } else {
      this.setState({
        errors: { imageFileName: message.ValidImageTypeRequired },
      });
      return;
    }
  };
  handleDeleteProfileImage = async (e: any) => {
    e.preventDefault();
    const { email, imageFile, imageFileName } = this.state;
    const data = {
      email: email,
    };
    console.log(">>>>>>>>>>>>>>>>>>", data);
    // To validate form

    if (email != undefined || email != null) {
      const { deleteProfileInfo } = this.props;
      if (deleteProfileInfo) {
        this.setState({
          loading: true,
        });
        deleteProfileInfo({
          ...data,
        });
      }
    } else {
      this.setState({
        errors: { imageFileName: message.ValidImageTypeRequired },
      });
      return;
    }
  };

  render() {
    const { imageFileName, errors } = this.state;
    return (
      <div className="main-section">
        <div className="col-lg-12 col-md-12">
          <div className="profile-form">
            <Form className="row" onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="d-flex align-items-center">
                  <h4 className="mb-5">
                    Upload image <span className="border-heading" />
                  </h4>
                  <button className="btn btn-submit mb-5 ml-auto" type="submit">
                    Save Changes
                  </button>
                </div>
              </div>
              <Form.Group className="col-md-12">
                <div className="row">
                  <div className="col-md-6 align-self-center">
                    <InputGroup>
                      <input
                        type="file"
                        className="custom-file-input"
                        id="userImage"
                        aria-describedby="inputGroupFileAddon01"
                        accept="image/x-png,image/gif,image/jpeg"
                        onChange={this.handleImageFileSelect}
                      />
                      <label className="custom-file-label" htmlFor="userImage">
                        Choose file
                      </label>
                    </InputGroup>
                  </div>
                  <div className="col-md-6 text-right align-self-center mt-1">
                    <span>
                      <i
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={(e) => {
                          console.log("delete image");
                          this.handleDeleteProfileImage(e);
                        }}
                        className="fa fa-trash"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </div>
                <div className={"text-info mt-1"}>
                  {!errors && imageFileName}
                </div>
                <div className={"text-danger mt-2 error-text-password"}>
                  {errors && errors.imageFileName}
                </div>
              </Form.Group>
              <div className="col-md-12 mt-3">
                <div className="text-info d-flex align-items-center">
                  Note: Image should have 165*180 size
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  profileReducer: state.profileReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getProfileInfo: () => {
      dispatch(getProfileRequest());
    },
    updateProfileInfo: (data: any) => {
      dispatch(updateImageRequest(data));
    },
    deleteProfileInfo: (data: any) => {
      dispatch(deleteImageRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadImage);
